import { NgModule } from '@angular/core';
import { AutofocusDirective } from './autofocus.directive';
import { DigitDecimalNumberDirective } from './digit-decimal-number.directive';

@NgModule({
  declarations: [AutofocusDirective, DigitDecimalNumberDirective],
  exports: [AutofocusDirective, DigitDecimalNumberDirective],
})
export class DirectiveModule {}
